import firebase from 'firebase/compat/app';
import Economy from 'dt-common/constants/Economy';
import Config from '~/constants/Config';
import { CurrencyDispatcher } from '~/flux/dispatchers';
import mutationProcessYandexPurchase from '~/graphql/payments/mutationProcessYandexPurchase';
import { logError } from '~/logger';
import { PaymentsStoreMessage } from '../messages';

export default async function initYandexPurchase(
  {
    playerId,
    emit,
  }: {
    playerId: string | null;
    emit: (message: PaymentsStoreMessage, data?: unknown) => void;
  },
  action: { purchase_selection: { id: string } }
) {
  if (!playerId) throw new Error('playerId required');

  const { purchase_selection } = action;
  try {
    const payments = await ysdk.getPayments({ signed: true });
    const purchase = await payments.purchase({ id: purchase_selection.id });

    const result = await mutationProcessYandexPurchase({
      playerId,
      purchase,
      platform: Config.PLATFORM,
    });

    await payments.consumePurchase(purchase.purchaseToken);

    if (result.currency1 != null) {
      CurrencyDispatcher.handleCurrencyAction({
        actionType: CurrencyDispatcher.NEW_CURRENCY_BALANCE,
        currency1: result.currency1,
      });
    }

    emit('YANDEX_PURCHASE_COMPLETE', purchase);

    if (process.env.DT_TIER === 'production') {
      const item = (Economy.PREMIUM_ITEM_DICT as Record<string, { usd_cents: number }>)[purchase.productID];
      firebase.analytics().logEvent('purchase', {
        value: item.usd_cents / 100,
        currency: 'USD',
        transaction_id: purchase.purchaseToken,
        items: [{ item_id: purchase.productID }],
      });
    }
  } catch (err) {
    logError(err, {
      module: 'PaymentsStore',
      func: 'initYandexPurchase',
    });
  }
}
